import { DataTypeProvider } from '@devexpress/dx-react-grid';
import NRValueTooltipIcon from './NRValueTooltipIcon';
import NRGenericIcon from '../../../NRIcons/NRPackageManagerIcons/NRGenericIcon';
import NRAPTDebianIcon from '../../../NRIcons/NRPackageManagerIcons/NRAPTDebianIcon';
import NRNPMIcon from '../../../NRIcons/NRPackageManagerIcons/NRNPMIcon';
import NRMavenIcon from '../../../NRIcons/NRPackageManagerIcons/NRMavenIcon';
import NRPyPiIcon from '../../../NRIcons/NRPackageManagerIcons/NRPyPiIcon';
import NRNuGetIcon from '../../../NRIcons/NRPackageManagerIcons/NRNuGetIcon';
import NRGoIcon from '../../../NRIcons/NRPackageManagerIcons/NRGoIcon';
import NRRPMIcon from '../../../NRIcons/NRPackageManagerIcons/NRRPMIcon';
import NRCargoIcon from '../../../NRIcons/NRPackageManagerIcons/NRCargoIcon';
import NRGradleIcon from '../../../NRIcons/NRPackageManagerIcons/NRGradleIcon';
import NRGithubIcon from '../../../NRIcons/NRPackageManagerIcons/NRGithubIcon';
import NRDockerIcon from '../../../NRIcons/NRPackageManagerIcons/NRDockerIcon';
import NRBitbucket from '../../../NRIcons/NRPackageManagerIcons/NRBitbucket';
import { SBOM_TABLE_CONSTANTS } from '../../../pages/NRSBOMTable/NRSBOMTable.constants';
import NRAlpineIcon from '../../../NRIcons/NRPackageManagerIcons/NRAlpineIcon';
import NRPacmanIcon from '../../../NRIcons/NRPackageManagerIcons/NRPacmanIcon';
import { NRHandleEmptyCellValue } from '../CellComponent/CellComponent';
import { CONSTANTS } from '../../../constants/constants';
import { confidenceAttr } from './NRSBOMNameProvider';
import { SBOM_CONSTANTS } from '../../SBOM/SBOM.constants';
import NROpenWRT from '../../../NRIcons/NRPackageManagerIcons/NROpenWRT';
import NROpenWRTDark from '../../../NRIcons/NRPackageManagerIcons/NROpenWRTDark';
import { useTheme } from '@mui/material/styles';
import NRAlpineIconDark from '../../../NRIcons/NRPackageManagerIcons/NRAlpineIconDark';
import NRRPMIconDark from '../../../NRIcons/NRPackageManagerIcons/NRRPMIconDark';
import NRNuGetIconDark from '../../../NRIcons/NRPackageManagerIcons/NRNuGetIconDark';
import NRWindowsIcon from '../../../NRIcons/NRPackageManagerIcons/NRWindowsIcon';
import NRJavaIcon from '../../../NRIcons/NRPackageManagerIcons/NRJavaIcon';
import NRAITag from '../../../NRIcons/NRAITag';

export const PACKAGE_MANAGER_ICONS = {
  DEB: {
    ICON: <NRAPTDebianIcon width={20} height={20} />,
    NAME: 'Apt Debian',
    TOOLTIP: 'APT Debian'
  },
  PYPI: {
    ICON: <NRPyPiIcon width={20} height={20} />,
    NAME: 'PyPi',
    TOOLTIP: 'PyPi Manager'
  },
  NPM: {
    ICON: <NRNPMIcon width={20} height={20} />,
    NAME: 'NPM',
    TOOLTIP: 'Node Package Manager'
  },
  GRADLE: {
    ICON: <NRGradleIcon width={20} height={20} />,
    NAME: 'Gradle',
    TOOLTIP: 'Gradle Package Manager'
  },
  NUGET: {
    ICON: <NRNuGetIcon width={20} height={20} />,
    ICON_DARK: <NRNuGetIconDark width={20} height={20} />,
    NAME: 'Nuget',
    TOOLTIP: 'Nuget'
  },
  GOLANG: {
    ICON: <NRGoIcon width={20} height={20} />,
    NAME: 'Go',
    TOOLTIP: 'Go'
  },
  MAVEN: {
    ICON: <NRMavenIcon width={20} height={20} />,
    NAME: 'Maven',
    TOOLTIP: 'Maven'
  },
  JAR: {
    ICON: <NRJavaIcon width={20} height={20} />,
    NAME: 'Java',
    TOOLTIP: 'Java'
  },
  RPM: {
    ICON: <NRRPMIcon width={20} height={20} />,
    ICON_DARK: <NRRPMIconDark width={20} height={20} />,
    NAME: 'RPM',
    TOOLTIP: 'RPM'
  },
  CARGO: {
    ICON: <NRCargoIcon width={20} height={20} />,
    NAME: 'Cargo',
    TOOLTIP: 'Cargo'
  },
  GITHUB: {
    ICON: <NRGithubIcon width={20} height={20} />,
    NAME: 'Github',
    TOOLTIP: 'Github'
  },
  DOCKER: {
    ICON: <NRDockerIcon width={20} height={20} />,
    NAME: 'Docker',
    TOOLTIP: 'Docker'
  },
  BITBUCKET: {
    ICON: <NRBitbucket width={20} height={20} />,
    NAME: 'Bitbucket',
    TOOLTIP: 'Bitbucket'
  },
  ALPINEAPK: {
    ICON: <NRAlpineIcon width={20} height={20} />,
    ICON_DARK: <NRAlpineIconDark width={20} height={20} />,
    NAME: 'Alpine',
    TOOLTIP: 'Alpine'
  },
  PACMAN: {
    ICON: <NRPacmanIcon width={20} height={20} />,
    NAME: 'Pacman',
    TOOLTIP: 'Pacman'
  },
  OPENWRT: {
    ICON: <NROpenWRT width={20} height={20} />,
    ICON_DARK: <NROpenWRTDark width={20} height={20} />,
    NAME: 'OpenWRT',
    TOOLTIP: 'OpenWRT'
  },
  WINDOWS: {
    ICON: <NRWindowsIcon width={20} height={20} />,
    NAME: 'Windows',
    TOOLTIP: 'Windows'
  },
  AI_MODEL: {
    ICON: <NRAITag width={20} height={20} sx={theme => ({ color: theme.palette.riseAiPurple })} />,
    NAME: 'AI Model',
    TOOLTIP: 'AI Model'
  },
  DEFAULT: {
    ICON: <NRGenericIcon width={20} height={20} />,
    TOOLTIP: 'Unidentified Package Manager'
  }
};

const SBOMTypeFormatter = ({ value, row, column }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const isLowConfidence = row[confidenceAttr] === CONSTANTS.SEVERITIES.LOW.toUpperCase();
  const isPackage = row?.dependency?.type === SBOM_TABLE_CONSTANTS.PACKAGE || column?.title?.value === SBOM_TABLE_CONSTANTS.PACKAGE_MANAGER;
  const isGroupedTable = column?.title?.value === SBOM_TABLE_CONSTANTS.PACKAGE_MANAGER;
  const packageType = row?.dependency?.package?.type || row?.subtype;
  const iconDefinition = (!!packageType && PACKAGE_MANAGER_ICONS[packageType?.toUpperCase()]) || PACKAGE_MANAGER_ICONS.DEFAULT;
  const icon = isDarkMode ? iconDefinition?.ICON_DARK || iconDefinition?.ICON : iconDefinition?.ICON;

  const tooltip = PACKAGE_MANAGER_ICONS[packageType?.toUpperCase()]?.TOOLTIP || packageType || PACKAGE_MANAGER_ICONS.DEFAULT.TOOLTIP;
  const valueToUse =
    (isPackage && isGroupedTable ? PACKAGE_MANAGER_ICONS[packageType?.toUpperCase()]?.NAME : SBOM_CONSTANTS.TYPE_COLUMN_MAP[value]) || value;
  return (
    <>
      {value ? (
        <NRValueTooltipIcon
          value={valueToUse}
          icon={isPackage && !isLowConfidence ? icon : null}
          tooltip={!isLowConfidence ? tooltip : null}
          tooltipComponent={
            <span>
              Package Match: <b>{tooltip}</b>
            </span>
          }
        />
      ) : (
        <NRHandleEmptyCellValue />
      )}
    </>
  );
};
export const NRSBOMTypeProvider = props => <DataTypeProvider formatterComponent={SBOMTypeFormatter} {...props} />;
